import classNames from 'classnames';
import { memo } from 'react';

import styles from './index.less';

interface IProps {
  className?: string;
  dotItemClassName?: string;
  dotShadowClassName?: string;
}

function DotsLoading({ className, dotItemClassName, dotShadowClassName }: IProps): JSX.Element {
  return (
    <div className={classNames(styles.dotsLoading, className)}>
      <div className={styles.dots}>
        <div className={classNames(styles.dotItem, dotItemClassName)} />
        <div className={classNames(styles.dotItem, dotItemClassName)} />
        <div className={classNames(styles.dotItem, dotItemClassName)} />

        {/* shadow */}
        <div className={classNames(styles.dotShadow, dotShadowClassName)} />
        <div className={classNames(styles.dotShadow, dotShadowClassName)} />
        <div className={classNames(styles.dotShadow, dotShadowClassName)} />
      </div>
    </div>
  );
}

export default memo(DotsLoading);
